export const addBurger = (burger, quantity = 1) => ({
  type: "ADD_BURGER",
  payload: {
    quantity,
    burger,
  },
});

export const editBurger = (index, burger, quantity = 1) => ({
  type: "EDIT_BURGER",
  payload: {
    index,
    quantity,
    burger,
  },
});

export const addSideItem = (sideItem) => ({
  type: "ADD_SIDE_ITEM",
  payload: sideItem,
});

export const setCartInfo = (info) => ({
  type: "SET_CART_INFO",
  payload: info,
});

export const resetCart = () => ({
  type: "RESET_CART",
});
